(() => {
  const state = window.__lioraBrandLoader;

  if (!state || !state.root || !state.root.isConnected) return;

  const root = state.root;
  const number = root.querySelector('.liora-brand-loader__number');
  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const configuredMinimum = Number.parseInt(root.dataset.minDuration, 10);
  const minimumDuration = Number.isFinite(configuredMinimum) ? configuredMinimum : 1200;
  const warmUpDuration = 900;
  const finishDuration = 200;
  const holdDuration = 230;
  const exitDuration = 560;
  const hardFinishAt = 2950;
  let loadComplete = document.readyState === 'complete';
  let currentProgress = 0;
  let finishing = false;
  let animationFrame = 0;

  const renderProgress = (value) => {
    currentProgress = Math.max(currentProgress, Math.min(100, value));
    const rounded = Math.round(currentProgress);
    root.style.setProperty('--liora-loader-progress', `${currentProgress / 100}`);

    if (number) number.textContent = String(rounded).padStart(2, '0');
  };

  const removeLoader = () => {
    window.cancelAnimationFrame(animationFrame);
    window.clearTimeout(state.hardTimeout);
    state.unlockPage();
    root.remove();
    delete window.__lioraBrandLoader;
  };

  const exitLoader = () => {
    root.classList.add(reduceMotion ? 'is-fading' : 'is-exiting');
    window.setTimeout(removeLoader, reduceMotion ? 180 : exitDuration + 40);
  };

  const finish = () => {
    if (finishing || !root.isConnected) return;
    finishing = true;

    if (reduceMotion) {
      renderProgress(100);
      window.setTimeout(exitLoader, 80);
      return;
    }

    const finishStartedAt = performance.now();
    const finishStartedFrom = currentProgress;

    const finishFrame = (now) => {
      const ratio = Math.min((now - finishStartedAt) / finishDuration, 1);
      const eased = 1 - Math.pow(1 - ratio, 3);
      renderProgress(finishStartedFrom + (100 - finishStartedFrom) * eased);

      if (ratio < 1) {
        animationFrame = window.requestAnimationFrame(finishFrame);
      } else {
        renderProgress(100);
        window.setTimeout(exitLoader, holdDuration);
      }
    };

    animationFrame = window.requestAnimationFrame(finishFrame);
  };

  const warmUpFrame = (now) => {
    if (finishing || !root.isConnected) return;

    const elapsed = now - state.startedAt;
    const warmRatio = Math.min(elapsed / warmUpDuration, 1);
    const eased = 1 - Math.pow(1 - warmRatio, 3);
    const waitingProgress = elapsed > warmUpDuration
      ? Math.min(96, 92 + ((elapsed - warmUpDuration) / 700))
      : 92 * eased;

    renderProgress(waitingProgress);

    const earliestFinishAt = Math.max(
      warmUpDuration,
      minimumDuration - finishDuration - holdDuration - exitDuration
    );

    if ((loadComplete && elapsed >= earliestFinishAt) || elapsed >= hardFinishAt) {
      finish();
      return;
    }

    animationFrame = window.requestAnimationFrame(warmUpFrame);
  };

  const handlePageHide = () => {
    if (window.__lioraBrandLoader) window.__lioraBrandLoader.removeImmediately();
  };

  window.addEventListener('load', () => {
    loadComplete = true;
  }, { once: true });

  window.addEventListener('pagehide', handlePageHide, { once: true });
  window.addEventListener('pageshow', (event) => {
    if (event.persisted && window.__lioraBrandLoader) {
      window.__lioraBrandLoader.removeImmediately();
    }
  });

  renderProgress(0);
  window.requestAnimationFrame(() => {
    root.classList.add('is-visible');
    animationFrame = window.requestAnimationFrame(warmUpFrame);
  });
})();
